<script setup>
import Divider from "primevue/divider";
import Avatar from "primevue/avatar";
import Button from "primevue/button";
import Menu from 'primevue/menu';
import { ref, computed, onMounted } from "vue";
import { useEmployeeStore } from "@/stores/employee.js";
import { useAuthStore } from '@/stores/auth.js'
import {useRouter} from "vue-router";
import { usePermissions } from '@/composables/usePermissions.js';



const menu = ref();
const items = ref([
  {
    items: [
      {
        label: 'Отделы',
        command: () => router.push('/settings/departments')
      },
      {
        label: 'Должности',
        command: () => router.push('/settings/positions')
      },
      {
        label: 'Типы документов',
        command: () => router.push('/settings/document-types')
      }
    ]
  }
]);

const toggle = (event) => {
  menu.value.toggle(event);
};

const employeeStore = useEmployeeStore();
const currentUser = computed(() => employeeStore.currentUser);
const auth = useAuthStore()
const router = useRouter()
const { hasPermission } = usePermissions()

const apiOrigin = computed(() => {
  try {
    const u = new URL(import.meta.env.VITE_API_BASE_URL, window.location.origin);
    return u.origin;
  } catch {
    return window.location.origin;
  }
});
const fileUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${apiOrigin.value}${path.startsWith('/') ? '' : '/'}${path}`;
};

const avatarUrl = computed(() => fileUrl(currentUser.value?.avatar));
const initials = computed(() => {
  const firstName = currentUser.value?.first_name || '';
  const lastName = currentUser.value?.last_name || '';
  return ((firstName[0] || '') + (lastName[0] || '')).toUpperCase() || '?';
});
const profileUrl = computed(() => currentUser.value?.id ? `/employees/${currentUser.value.id}` : '/employees');



onMounted(() => {
  if (!employeeStore.currentUser) {
    employeeStore.fetchCurrentUser();
  }
});

async function onLogout() {
  try {
    await auth.logout()
    try { employeeStore.currentUser = null } catch {}
    await router.replace({ path: '/login', query: { redirect: undefined } })
    setTimeout(() => {
      if (window.location.pathname !== '/login') {
        window.location.replace('/login')
      }
    }, 0)
  } catch (e) {
    window.location.replace('/login')
  }
}
</script>


<template>
  <div class="w-auto rounded-2xl p-3 bg-surface-100 max-h-screen flex flex-col justify-between">
    <!-- Верх: Логотип и меню -->
    <div class="w-12 flex flex-col items-center">
      <!-- Логотип -->
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 flex items-center justify-center">
          <img src="/src/assets/logo_small.svg" alt="Lims logo">
        </div>
      </div>

      <!-- Меню -->
      <div class="mt-2 flex flex-col gap-2">
        <RouterLink to="/">
          <Button icon="pi pi-home" severity="secondary" aria-label="Home" v-tooltip="'Главная'" />
        </RouterLink>

        <RouterLink to="/customers" v-if="hasPermission('customer.view_customer')">
          <Button icon="pi pi-briefcase" severity="secondary" aria-label="Customers" v-tooltip="'Клиенты'" />
        </RouterLink>
        <RouterLink to="/contacts" v-if="hasPermission('contact.view_contact')">
          <Button icon="pi pi-address-book" severity="secondary" aria-label="Contacts" v-tooltip="'Контакты'" />
        </RouterLink>

        <RouterLink to="/facilities" v-if="hasPermission('facility.view_facility')">
          <Button icon="pi pi-building" severity="secondary" aria-label="Facilities" v-tooltip="'Объекты'" />
        </RouterLink>

        <RouterLink to="/contracts" v-if="hasPermission('contract.view_contract')">
          <Button icon="pi pi-folder" severity="secondary" aria-label="Contracts"  v-tooltip="'Договоры'" />
        </RouterLink>

        <RouterLink to="/works" v-if="hasPermission('work.view_work')">
          <Button icon="pi pi-clipboard" severity="secondary" aria-label="Works" v-tooltip="'Работы'"/>
        </RouterLink>

<!--        <Button icon="pi pi-file-edit" severity="secondary" aria-label="Documents" v-tooltip="'Документы'" />-->
        <RouterLink to="/map" v-if="hasPermission('facility.view_facility')">
          <Button icon="pi pi-map" severity="secondary" aria-label="Archive" v-tooltip="'Карта'" />
        </RouterLink>
        <RouterLink to="/employees" v-if="hasPermission('employee.view_employeeprofile')">
          <Button icon="pi pi-face-smile" severity="secondary" aria-label="Employees" v-tooltip="'Сотрудники'"/>
        </RouterLink>
      </div>
    </div>

    <!-- Низ: Настройки и аватар -->
    <div class="w-12 flex flex-col items-center">
      <div class="mt-10 flex flex-col gap-2">
        <Button icon="pi pi-cog" severity="secondary" aria-label="Home" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu"/>
        <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
      </div>
      <Divider class="w-full" />
      <div class="justify-center flex items-center">
        <RouterLink :to="profileUrl" class="block">
          <Avatar
            v-if="avatarUrl"
            :image="avatarUrl"
            size="large"
            shape="circle"
            v-tooltip="'Мой профиль'"
          />
          <Avatar
            v-else
            :label="initials"
            size="large"
            shape="circle"
            v-tooltip="'Мой профиль'"
            style="background-color: #9ca3af; color: white;"
          />
        </RouterLink>
      </div>
      <Button icon="pi pi-power-off" severity="secondary" v-tooltip="'Выйти'" @click="onLogout" />
    </div>
  </div>
</template>



<style scoped>

</style>